var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 4.5H9V3C9 1.3455 7.6545 0 6 0C4.3455 0 3 1.3455 3 3V4.5H2.625C2.005 4.5 1.5 5.0045 1.5 5.625V10.875C1.5 11.4955 2.005 12 2.625 12H9.375C9.995 12 10.5 11.4955 10.5 10.875V5.625C10.5 5.0045 9.995 4.5 9.375 4.5ZM4 3C4 1.897 4.897 1 6 1C7.103 1 8 1.897 8 3V4.5H4V3ZM6.5 8.361V9.5C6.5 9.776 6.2765 10 6 10C5.7235 10 5.5 9.776 5.5 9.5V8.361C5.2025 8.1875 5 7.8685 5 7.5C5 6.9485 5.4485 6.5 6 6.5C6.5515 6.5 7 6.9485 7 7.5C7 7.8685 6.7975 8.1875 6.5 8.361Z",
    fill: "cureent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.5994c70598ff0d59a8310d2403f7985e.svg";
export { ForwardRef as ReactComponent };